{
  "screen": {
    "sectionHeading": "Patientuppgifter",
    "headingCorrect": "Rätta patientuppgifter",
    "headingComplete": "Komplettera patientuppgifter",
    "openCorrect": "Rätta uppgifter",
    "openComplete": "Komplettera uppgifter",
    "explanationCorrect": "För uppgifter som blev fel. Gäller namn, födelsedatum och kön.",
    "explanationComplete": "För en patient som identifierats efter inskrivningen. Gäller namn, födelsedatum och kön.",
    "appendOnly": "Den nuvarande versionen tas inte bort. Det du sparar blir en ny version, och båda finns kvar i journalen med vem som skrev dem.",
    "identifierUnchanged": "Reservnummer och personnummer ändras inte här. Bandet, etiketterna och tidigare anteckningar fortsätter att peka på samma patient.",
    "requiredHint": "Fält utan anmärkning måste fyllas i.",
    "optional": "frivilligt",
    "saveCorrect": "Spara rättelsen",
    "saveComplete": "Spara uppgifterna",
    "saving": "Sparar …",
    "cancel": "Avbryt",
    "close": "Stäng",
    "discardQuestion": "Stäng formuläret? Det du har ändrat sparas inte.",
    "discardConfirm": "Stäng utan att spara",
    "discardCancel": "Fortsätt fylla i",
    "savedOk": "Uppgifterna är sparade.",
    "openPatient": "Tillbaka till patientöversikten",
    "estimatedIdentity": "Identiteten är antagen, inte styrkt"
  },
  "fieldHint": {
    "isEstimatedIdentity": "Låt rutan vara markerad så länge identiteten är ett antagande. Avmarkera den när du har styrkt vem patienten är — du dokumenterar din egen bedömning, journalen gör ingen kontroll."
  },
  "refusal": {
    "versionStale": "Någon annan har sparat en ny version av patientuppgifterna medan formuläret var öppet. De inlästa uppgifterna är nu de senaste — kontrollera vad du har skrivit och spara igen. Det du skrev sparades inte.",
    "noChange": "Inget är ändrat jämfört med journalen. Ingen ny version skrevs.",
    "patientNotFound": "Patienten finns inte i journalen. Uppgifterna sparades inte.",
    "patientRetracted": "Patienten är makulerad i journalen och kan inte få en ny version. Uppgifterna sparades inte. Registrera en ny patient i stället om uppgifterna behövs.",
    "roleMayNotDocument": "Din roll får inte dokumentera i journalen. Uppgifterna sparades inte.",
    "supersedesMissing": "Formuläret vet inte vilken version det utgår från. Stäng patientöversikten och öppna den igen. Uppgifterna sparades inte.",
    "unknown": "Uppgifterna sparades inte. Försök igen.",
    "unavailable": "Ingen kontakt med servern. Uppgifterna sparades inte — låt formuläret vara öppet och försök igen."
  }
}
